import { render, staticRenderFns } from "./AdDetail.vue?vue&type=template&id=136e6dee&"
import script from "./AdDetail.vue?vue&type=script&lang=js&"
export * from "./AdDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports